import { auth } from 'firebase/app';
import React from 'react';
import Main from '../ui/Main';
import PureLogin from '../ui/PureLogin';

function Login() {
    const handleSignInWithGoogle = () => {
        auth().signInWithPopup(new auth.GoogleAuthProvider());
    }
    const handleSignInWithEmail = (username: string, password: string) => {
        auth().signInWithEmailAndPassword(username, password);
    }
    const handleSignInWithJerry = () => {
        handleSignInWithEmail('jerry.smith@supreme-potato.com', 'supersecretpassword');
    }
  return <Main>
    <PureLogin onSignInWithEmail={handleSignInWithEmail} onSignInWithGoogle={handleSignInWithGoogle} />
    {/* <Button onClick={handleSignInWithJerry}>Jerry's here</Button> */}
  </Main>
}

export default Login;